import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, { GProps, G as SVG_G, Path as SVG_Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent(SVG_Path);
const G = Animated.createAnimatedComponent(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <desc id="IMP.BLUE">{"#Vector":{"type":"SELECTOR","constraint":"none","width":20.000001907348633,"height":20.000001907348633},"tProps":{"type":"PROPS","SearchIconButton?":{"onPress":"Function"}},"#SearchIconButton":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.SearchIconButton?.onPress"},"constraint":"xMinYMin meet","width":20.000001907348633,"height":20.000001907348633}}</desc>
 * <g id="SearchIconButton">
 * <rect width="20" height="20" transform="translate(-0.000244141 -0.000488281)" fill="white" fill-opacity="0.01"/>
 * <g id="Vector">
 * <path d="M7.27882 15.0997C3.27533 15.0997 -0.000244141 11.7021 -0.000244141 7.54959C-0.000244141 3.39705 3.27533 -0.000488281 7.27882 -0.000488281C11.2823 -0.000488281 14.5579 3.39705 14.5579 7.54959C14.5579 11.7021 11.2823 15.0997 7.27882 15.0997ZM7.27882 1.25786C3.88192 1.25786 1.21293 4.02622 1.21293 7.54959C1.21293 11.073 3.88192 13.8413 7.27882 13.8413C10.6757 13.8413 13.3447 11.073 13.3447 7.54959C13.3447 4.02622 10.5544 1.25786 7.27882 1.25786Z" fill="#373938"/>
 * <path d="M12.2516 11.6412L11.4277 12.565L19.1759 19.9995L19.9998 19.0758L12.2516 11.6412Z" fill="#373938"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 20.000001907348633,
 * 		"height": 20.000001907348633
 * 	},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"SearchIconButton?": "tButtonProps",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#SearchIconButton": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.SearchIconButton?.onPress",
 * 			"animation": "touchableOpacity"
 * 		},
 * 		"constraint": "xMinYMin meet",
 * 		"width": 20.000001907348633,
 * 		"height": 20.000001907348633
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  SearchIconButton?: tButtonProps;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Button Prop Types */

type tButtonProps = {
  onPress: () => void;
} & GProps;
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const SearchIconButton = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  SearchIconButton?: tButtonProps;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 20,
      height: 20,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  const [buttonState, setButtonState] = React.useState<{
    SearchIconButtonButtonOpacity: number;
  }>({
    SearchIconButtonButtonOpacity: 1,
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Button Wrapper */
  // #region SearchIconButton Button Handlers

  const { SearchIconButton: SearchIconButton2 } = props;
  const { onPress: SearchIconButtonOnPress, ...SearchIconButtonProps } = SearchIconButton2 as tButtonProps;

  const SearchIconButtonButtonPressInFunction = () => 0;

  const SearchIconButtonButtonPressOutFunction = SearchIconButtonOnPress;

  const SearchIconButtonButtonActive = (callback?: () => void) => {
    setButtonState({ ...buttonState, SearchIconButtonButtonOpacity: 0.2 });

    if (callback) {
      callback();
    }
  };

  const SearchIconButtonButtonInactive = (callback?: () => void) => {
    setButtonState({ ...buttonState, SearchIconButtonButtonOpacity: 1 });

    if (callback) {
      callback();
    }
  };

  const SearchIconButtonOnPressIn = () => {
    SearchIconButtonButtonActive(SearchIconButtonButtonPressInFunction);
  };

  const SearchIconButtonOnPressOut = () => {
    SearchIconButtonButtonInactive(SearchIconButtonButtonPressOutFunction);
  };
  /***/
  // #endregion

  /** End Button Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 20 20"
        >
          <G
            id="SearchIconButton"
            opacity={buttonState.SearchIconButtonButtonOpacity}
            onMouseDown={SearchIconButtonOnPressIn}
            onMouseUp={SearchIconButtonOnPressOut}
            cursor="pointer"
            {...SearchIconButtonProps}
          >
            <Path
              transform="translate(-0.000244141 -0.000488281)"
              fill="white"
              fillOpacity={0.01}
              id="SearchIconButton_elem0"
              d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
            <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
              <G id="Vector">
                <Path
                  d="M7.27882 15.0997C3.27533 15.0997 -0.000244141 11.7021 -0.000244141 7.54959C-0.000244141 3.39705 3.27533 -0.000488281 7.27882 -0.000488281C11.2823 -0.000488281 14.5579 3.39705 14.5579 7.54959C14.5579 11.7021 11.2823 15.0997 7.27882 15.0997ZM7.27882 1.25786C3.88192 1.25786 1.21293 4.02622 1.21293 7.54959C1.21293 11.073 3.88192 13.8413 7.27882 13.8413C10.6757 13.8413 13.3447 11.073 13.3447 7.54959C13.3447 4.02622 10.5544 1.25786 7.27882 1.25786Z"
                  fill="#373938"
                  id="Vector_elem0"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  d="M12.2516 11.6412L11.4277 12.565L19.1759 19.9995L19.9998 19.0758L12.2516 11.6412Z"
                  fill="#373938"
                  id="Vector_elem1"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          transform="translate(-0.000244141 -0.000488281)"
          fill="white"
          fillOpacity={0.01}
          id="SearchIconButton_elem0"
          d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="Vector">
          <Path
            d="M7.27882 15.0997C3.27533 15.0997 -0.000244141 11.7021 -0.000244141 7.54959C-0.000244141 3.39705 3.27533 -0.000488281 7.27882 -0.000488281C11.2823 -0.000488281 14.5579 3.39705 14.5579 7.54959C14.5579 11.7021 11.2823 15.0997 7.27882 15.0997ZM7.27882 1.25786C3.88192 1.25786 1.21293 4.02622 1.21293 7.54959C1.21293 11.073 3.88192 13.8413 7.27882 13.8413C10.6757 13.8413 13.3447 11.073 13.3447 7.54959C13.3447 4.02622 10.5544 1.25786 7.27882 1.25786Z"
            fill="#373938"
            id="Vector_elem0"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            d="M12.2516 11.6412L11.4277 12.565L19.1759 19.9995L19.9998 19.0758L12.2516 11.6412Z"
            fill="#373938"
            id="Vector_elem1"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(SearchIconButton);
